import React from 'react'

const AccountNotFound = () => {
  return (
    <div className="page-content m-auto">
    <div className="white-space d-flex justify-content-center">
      <div className="white-c">
        <div className="soon align-self-end"
          style={{
            fontSize: "40px",
          }}
        >Account not found</div>
      </div>
    </div>
  </div>
  )
}

export default AccountNotFound